import { HoverCard, HoverCardContent, HoverCardTrigger } from '@chain-zen/ui'

import type { TSFTPSource } from '../../../types/tracking'
import { SFTPInfo } from './sftp-info'
import { SFTPTrackingInfo } from './sftp-tracking-info'

interface ISFTPSourceProps {
  shipmentID: string
  trackingSourceData: TSFTPSource
}

/**
 * SFTPSource displays the SFTP tracking data for the shipment.
 */
export const SFTPSource = (props: ISFTPSourceProps) => {
  const { trackingSourceData, shipmentID } = props

  return (
    <HoverCard>
      <HoverCardTrigger className="w-full">
        <div className="w-full">
          <SFTPInfo trackingSourceData={trackingSourceData} shipmentID={shipmentID} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-full text-sm" side="top">
        <SFTPTrackingInfo trackingSourceData={trackingSourceData as TSFTPSource} />
      </HoverCardContent>
    </HoverCard>
  )
}
